var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.updateTime)?_c('div',[_c('span',{staticClass:"text-muted font-12"},[_vm._v("Güncelleme: "+_vm._s(_vm._f("dateFormat")(_vm.updateTime)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }